PetcoEmailSignup ={
		langId: "-1",
		storeId: "",
		catalogId: "",

		setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;

					},

	    closeEmailWindow:function(){

			 var formName = document.getElementById("emailSignup");
	    $(':input', formName).each(function () {
	    	var type = this.type;
	    	var id = this.id;
	    	if (type == 'text')
	    		this.value = "";
	    }); 
	    petcoCommonJS.hideModal('modal-emailsignupwidget');  





},
emailsignupError:function(form){
	document.getElementById("error_message_server").style.display = "none";

		var formSubmit = true;
	var firstName_div =  dojo.byId('firstName_DIV');
	var firstNameError_div = dojo.byId('firstName_ERROR');
	var emailAddress_div =  dojo.byId('emailAddress_DIV');
	var emailAddressError_div = dojo.byId('emailAddress_ERROR');

	if(null!=form && form){
		reWhiteSpace = new RegExp(/^\s+$/);	
		var alphaWithSpace = new RegExp(/^[a-zA-Z]+[\sa-zA-Z]*$/i);
		var alphanumeric = new RegExp(/^[a-zA-z0-9]+$/i);
		var alphaWithDashAndSingleQuote = new RegExp(/^[a-zA-Z]+((([-]?[\sa-zA-Z]+)?([']?[\sa-zA-Z]+)?)|(([']?[\sa-zA-Z]+)?([-]?[\sa-zA-Z]+)?))?[a-zA-Z]*$/i);
		var numeric = new RegExp(/^[0-9]+$/);
		var reValidEmail = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

				if(form.firstName != null && (reWhiteSpace.test(form.firstName.value) || form.firstName.value == "")){ 
			firstName_div.className="form-group has-error";
			firstNameError_div.innerHTML = '<span class="help-block">' + MessageHelper.messages["_ERR_EMAILPREF_FIELD_REQUIRED"] + '</span>';
			formSubmit = false;
		}else if(!alphaWithDashAndSingleQuote.test(form.firstName.value)){
			firstName_div.className="form-group has-error";
			firstNameError_div.innerHTML = '<span class="help-block">' + MessageHelper.messages["REGISTRATION_ERR_ALPHA_TEXT"] + '</span>';
			formSubmit = false;						
		}
		else{
			firstName_div.className="form-group";
			firstNameError_div.innerHTML = "";
		}

				if(form.emailAddress != null && (reWhiteSpace.test(form.emailAddress.value) || form.emailAddress.value == "")){
			emailAddress_div.className="form-group has-error";
			emailAddressError_div.innerHTML = '<span class="help-block">' + MessageHelper.messages["_ERR_EMAILPREF_FIELD_REQUIRED"] + '</span>';
			formSubmit = false;
		}
		else if(form.emailAddress.value.length > 100){
			emailAddress_div.className="form-group has-error";
			emailAddressError_div.innerHTML = '<span class="help-block">' + MessageHelper.messages["_ERR_EMAILPREF_EXCEED_100_CHAR"] + '</span>';
			formSubmit = false;
		}
		else if(!reValidEmail.test(form.emailAddress.value)){
			emailAddress_div.className="form-group has-error";
			emailAddressError_div.innerHTML = '<span class="help-block">' + MessageHelper.messages["_ERR_EMAILPREF_INVALIDEMAILFORMAT"] + '</span>';
			formSubmit = false;
		}
		else if(form.emailAddress.value.match(/@/g).length > 1){
			emailAddress_div.className="form-group has-error";
			emailAddressError_div.innerHTML = '<span class="help-block">' + MessageHelper.messages["_ERR_EMAILPREF_INVALIDEMAILFORMAT"] + '</span>';
			formSubmit = false;				
		}
		else if(this.endsWith(form.emailAddress.value,'@dii.com')){
			emailAddress_div.className="form-group has-error";
			emailAddressError_div.innerHTML = '<span class="help-block">' + MessageHelper.messages["_ERR_EMAILPREF_INVALIDEMAILFORMAT"] + '</span>';
			formSubmit = false;	
		}
		else{
			emailAddress_div.className="form-group";
			emailAddressError_div.innerHTML = "";
		}
		if(formSubmit){
			var customerJSON = {"event_name" : "email_signup",
								"customer_name" : form.firstName.value, 
								"customer_email" : form.emailAddress.value, 
								"customer_newsletter" : "Newsletter Sign-up", 
								"conversion_event_id" : "Email Sign Up", 
								"conversion_category_id" :  "Email Sign Up",
								"conversion_action_type" : "1"};
			pushEvent(customerJSON);
			this.EmailSignupNewEmailAddress(emailSignup);
		}
		else{
			return false;
		}
		}
	return false;
	},
endsWith:function(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
},


ClearEmailSignUpForm:function(form) {
    var formName = document.getElementById("emailSignup");
    $(':input', formName).each(function () {
    	var type = this.type;
    	var id = this.id;
    	if (type == 'text')
    		this.value = "";
    }); 

		var firstName_div =  dojo.byId('firstName_DIV');
	var firstNameError_div = dojo.byId('firstName_ERROR');
	firstName_div.className="form-group";
	firstNameError_div.innerHTML = "";
	var emailAddress_div =  dojo.byId('emailAddress_DIV');
	var emailAddressError_div = dojo.byId('emailAddress_ERROR');
	emailAddress_div.className="input";
	emailAddressError_div.innerHTML = "";

	$(".modal-footer").show();
	$("#close-window").hide();

	},
EmailSignupNewEmailAddress:function(form){
	var params = [];
	params.storeId	= this.storeId;
	params.catalogId = this.catalogId;
	params.langId	= this.langId;

	params.firstName = document.getElementById("email-signup-first-name").value;
	params.emailAddress = document.getElementById("email-signup-email-address").value;

	wc.service.invoke("AjaxEmailSignupCmd", params); 
},

SignUpNewEmail:function(form) {


			var formSubmit = true;
	var emailAddress_div =  $('#emailAddress_DIV');
	var emailAddressError_div = $('#emailAddress_ERROR');

	if(null!=form && form){
		reWhiteSpace = new RegExp(/^\s+$/);	
		var alphaWithSpace = new RegExp(/^[a-zA-Z]+[\sa-zA-Z]*$/i);
		var alphanumeric = new RegExp(/^[a-zA-z0-9]+$/i);
		var alphaWithDashAndSingleQuote = new RegExp(/^[a-zA-Z]+((([-]?[\sa-zA-Z]+)?([']?[\sa-zA-Z]+)?)|(([']?[\sa-zA-Z]+)?([-]?[\sa-zA-Z]+)?))?[a-zA-Z]*$/i);
		var numeric = new RegExp(/^[0-9]+$/);
		var reValidEmail = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);


						if(form.emailAddress != null && (reWhiteSpace.test(form.emailAddress.value) || form.emailAddress.value == "")){
			$(emailAddress_div).find('input').addClass('invalid-box');
			$(emailAddressError_div).html('<span class="error">' + MessageHelper.messages["_ERR_EMAILPREF_FIELD_REQUIRED"] + '</span>');
			formSubmit = false;
		}
		else if(form.emailAddress.value.length > 100){
			$(emailAddress_div).find('input').addClass('invalid-box');
			$(emailAddressError_div).html('<span class="error">' + MessageHelper.messages["_ERR_EMAILPREF_EXCEED_100_CHAR"] + '</span>');
			formSubmit = false;
		}
		else if(!reValidEmail.test(form.emailAddress.value)){
			$(emailAddress_div).find('input').addClass('invalid-box');
			$(emailAddressError_div).html('<span class="error">' + MessageHelper.messages["_ERR_EMAILPREF_INVALIDEMAILFORMAT"] + '</span>');
			formSubmit = false;
		}
		else if(form.emailAddress.value.match(/@/g).length > 1){
			$(emailAddress_div).find('input').addClass('invalid-box');
			$(emailAddressError_div).html('<span class="error">' + MessageHelper.messages["_ERR_EMAILPREF_INVALIDEMAILFORMAT"] + '</span>');
			formSubmit = false;				
		}
		else if(this.endsWith(form.emailAddress.value,'@dii.com')){
			$(emailAddress_div).find('input').addClass('invalid-box');
			$(emailAddressError_div).html('<span class="error">' + MessageHelper.messages["_ERR_EMAILPREF_INVALIDEMAILFORMAT"] + '</span>');
			formSubmit = false;	
		}
		else{
			$(emailAddress_div).find('input').removeClass('invalid-box');
			$(emailAddressError_div).html('');
		}
		if(formSubmit){
			var eventJson={
					"event_name" : "email_signup",					
					"customer_email" : form.emailAddress.value,
					"email_sign_up_location" : "footer",
					"conversion_action_type" : "1", 
					"conversion_catergory_id" : "Email Sign Up", 
					"conversion_event_id" : "Email Sign Up"
					};
			pushEvent(eventJson);
			this.NewEmailSignupRequest(form.emailAddress.value);
		}
		else{
			return false;
		}
		}
	return false;

	},


NewEmailSignupRequest:function(emailId){
	var params = [];
	params.storeId	= '10151';
	params.catalogId = '10051';
	params.langId	= '-1';

		params.emailAddress = emailId;

	cursor_wait();
	wc.service.invoke("AjaxEmailSignupCmd", params); 
}
}